import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { RecaptchaComponent } from 'ng-recaptcha';

@Component({
  selector: 'app-contacto',
  templateUrl: './contacto.component.html',
  styleUrls: ['./contacto.component.css']
})
export class ContactoComponent implements OnInit, AfterViewInit {
  @ViewChild('recaptcha', { static: false }) recaptchaComponent!: RecaptchaComponent;
  
  contactoForm: FormGroup;
  submitted = false;
  loading = false;
  recaptchaToken: string = '';
  recaptchaSiteKey = environment.recaptcha.siteKey;

  constructor(
    private fb: FormBuilder, 
    private router: Router,
    private http: HttpClient
  ) {
    this.contactoForm = this.fb.group({
      nombre: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      empresa: ['', [Validators.required, Validators.minLength(2)]],
      telefono: ['', [Validators.required, Validators.pattern(/^[\d\s\-]{10,}$/), Validators.minLength(10), Validators.maxLength(10)]],
      asunto: ['', [Validators.required, Validators.minLength(5)]],
      mensaje: ['', [Validators.required, Validators.minLength(15)]],
      consentimiento: [false, [Validators.requiredTrue]]
    });
  }

  ngOnInit(): void {
    // Hacer scroll hacia arriba cuando se carga la página
    this.scrollToTop();
  }

  ngAfterViewInit(): void {
    // No necesitamos esperar, ng-recaptcha se encarga de la carga
  }

  private scrollToTop(): void {
    // Hacer scroll suave hacia arriba de la página
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onRecaptchaResolved(token: string): void {
    console.log('reCAPTCHA token generado exitosamente');
    this.recaptchaToken = token;
    this.contactoForm.patchValue({ recaptchaToken: token });
    
    // Una vez que tenemos el token, proceder con el envío automáticamente
    if (this.contactoForm.valid) {
      this.sendContactForm();
    }
  }

  async executeRecaptchaAndSubmit(): Promise<void> {
    if (this.loading) {
      return;
    }

    // Validar el formulario antes de ejecutar reCAPTCHA
    if (!this.contactoForm.valid) {
      this.submitted = true;
      return;
    }

    this.loading = true;
    
    try {
      if (this.recaptchaComponent) {
        await this.recaptchaComponent.execute();
      } else {
        console.error('Componente reCAPTCHA no disponible');
        this.loading = false;
      }
    } catch (error) {
      console.error('Error ejecutando reCAPTCHA:', error);
      this.loading = false;
    }
  }

  // Este método ya no es necesario para el flujo principal, pero lo mantenemos por compatibilidad
  onSubmit(): void {
    // Solo validar y mostrar errores, no enviar
    this.submitted = true;
    
    if (!this.contactoForm.valid) {
      return;
    }
    
    // Si el formulario es válido, ejecutar reCAPTCHA
    this.executeRecaptchaAndSubmit();
  }

  get f() {
    return this.contactoForm.controls;
  }

  // Calcular el progreso del formulario
  getFormProgress(): number {
    const totalFields = Object.keys(this.contactoForm.controls).length;
    let validFields = 0;
    
    Object.keys(this.contactoForm.controls).forEach(key => {
      const control = this.contactoForm.get(key);
      if (control && control.valid && control.value !== '' && control.value !== false) {
        validFields++;
      }
    });
    
    return Math.round((validFields / totalFields) * 100);
  }

  private sendContactForm(): void {
    const formData = this.contactoForm.value;
    
    // Asegurar que el token de reCAPTCHA esté presente
    formData.recaptchaToken = this.recaptchaToken;
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': environment.API_KEY
    });

    this.http.post(`${environment.API_BASE_URL}contact`, formData, { headers })
      .subscribe({
        next: (response: any) => {
          this.loading = false;
          this.submitted = false;
          this.contactoForm.reset();
          this.recaptchaToken = '';
          
          if (response.success) {
            alert('¡Gracias por tu mensaje! Te contactaremos en menos de 24 horas.');
            // Hacer scroll hacia arriba después del envío exitoso
            this.scrollToTop();
          } else {
            alert('Error: ' + (response.error || 'Error al enviar el mensaje'));
          }
        },
        error: (error: any) => {
          this.loading = false;
          console.error('Error enviando formulario:', error);
          
          let errorMessage = 'Error al enviar el mensaje';
          if (error.error && error.error.error) {
            errorMessage = error.error.error;
          }
          
          alert(errorMessage);
        }
      });
  }

  agendarDiagnostico(): void {
    // Scroll al formulario de contacto
    const contactForm = document.querySelector('.contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: 'smooth' });
    }
  }

  solicitarInformacion(): void {
    // Scroll al formulario de contacto
    const contactForm = document.querySelector('.contact-form');
    if (contactForm) {
      contactForm.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
